"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      colors = _useTheme.colors,
      spacing = _useTheme.spacing;

  return {
    root: {
      backgroundColor: colors.white,
      boxSizing: 'border-box',
      margin: spacing(-1, 0),
      '& > *': {
        margin: spacing(1, 0),
        justifyContent: 'flex-start'
      }
    }
  };
};

__signature__(useStyles, "useTheme{{ colors, spacing }}", function () {
  return [_useTheme2["default"]];
});

var Links = function Links(props) {
  var children = props.children;
  var classes = useStyles();
  return (0, _core.jsx)(_Flex["default"], {
    css: classes.root,
    width: "100%",
    flexDirection: "column",
    padding: [4, 2],
    alignItems: "stretch"
  }, children);
};

__signature__(Links, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Links;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/Links.tsx");
  reactHotLoader.register(Links, "Links", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/Links.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/Links.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();